import { graphql } from "gatsby";
import React, { FC } from "react";

import { RichText } from "../../rich-text";
import { HeroPortraitCardInner } from "./hero-portrait-inner-card";

export interface HeroPortraitProps extends Queries.HeroPortraitDataFragment {}

export const HeroPortrait: FC<HeroPortraitProps> = ({ title, abstract, contact }) => {
  return (
    <div className="flex flex-col lg:flex-row py-16 lg:py-24 px-8 lg:px-20 gap-12">
      {contact && (
        <HeroPortraitCardInner contact={contact} className="order-2 lg:order-1 mx-auto lg:mx-0" />
      )}
      <div className="flex flex-col gap-10 lg:gap-7 w-full lg:w-auto order-1 lg:order-2">
        {(title || abstract?.raw) && (
          <div className="flex flex-col gap-3 mb-7">
            {title && (
              <div className="font-medium text-primary text-5xl text-center lg:text-left">
                {title}
              </div>
            )}
            {abstract?.raw && (
              <RichText
                raw={abstract.raw}
                className="text-xl leading-snug text-center lg:text-left"
              />
            )}
          </div>
        )}
        {contact?.description?.raw && (
          <RichText
            className="font-light text-lg leading-snug [&_b]:font-bold"
            raw={contact.description.raw}
          />
        )}
      </div>
    </div>
  );
};

export const query = graphql`
  fragment HeroPortraitData on ContentfulHeroPortrait {
    title
    abstract {
      raw
    }
    contact {
      ...PortraitCardData
    }
  }
`;
